module.exports = __webpack_public_path__ + "img/Familienbild.ea83e154.jpg";